var map = {
	"./images/trainers-back.png": 211,
	"./images/trainers-box.png": 212,
	"./images/trainers-greenbox.png": 213,
	"./images/trainers-line.png": 214,
	"./images/trainers-logo.png": 215,
	"./images/trainers-next.png": 216,
	"./images/trainers-refresh.png": 217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;